<template>
  <div class="company-form">
    <div class="company-form__intro">
      <p class="company-form__copy">Registra la ficha principal con datos limpios y consistentes para mantener el directorio ordenado.</p>
    </div>
    <form action class="form company-form__fields" @submit.prevent="save">
      <div class="field company-form__field">
        <label class="label has-text-left company-form__label" for="#rut">RUT</label>
        <div class="control company-form__control">
          <input
            v-model="fullRut"
            class="input company-form__input"
            type="text"
            id="rut"
            required
            placeholder="12.345.678-9"
          >
        </div>
      </div>
      <div class="field company-form__field">
        <label class="label has-text-left company-form__label" for="#name">Nombre</label>
        <div class="control company-form__control">
          <input
            v-model="company.name"
            class="input company-form__input"
            type="text"
            id="name"
            placeholder="Nombre o razon social"
          >
        </div>
      </div>
      <div class="field company-form__field">
        <label class="label has-text-left company-form__label" for="#status">Estado</label>
        <div class="control company-form__control">
          <div class="select is-fullwidth company-form__select-wrap">
            <select v-model="company.status" id="status" class="company-form__select">
              <option v-for="status in companyStatuses" :key="status" :value="status">{{ status }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="field company-form__field">
        <label class="label has-text-left company-form__label" for="#client_type">Tipo de cliente</label>
        <div class="control company-form__control">
          <div class="select is-fullwidth company-form__select-wrap">
            <select v-model="company.client_type" id="client_type" class="company-form__select">
              <option v-for="clientType in clientTypes" :key="clientType.value" :value="clientType.value">{{ clientType.label }}</option>
            </select>
          </div>
        </div>
      </div>
      <ReviewSelector v-model="company.reviewer_id" />
      <p v-if="error" class="company-form__error">{{ this.strError }}</p>
    </form>
  </div>
</template>

<script>
import ReviewSelector from './ReviewSelector.vue'
export default {
  components: { ReviewSelector },
  data: () => ({
    company: {
      reviewer_id: null,
      rut: '',
      dv: '',
      name: '',
      status: 'Activo',
      client_type: 'empresa'
    },
    companyStatuses: ['Activo', 'Inactivo', 'Esporádico', 'TTG (Trámite de término de Giro)'],
    clientTypes: [
      { value: 'empresa', label: 'Empresa' },
      { value: 'persona_natural', label: 'Persona Natural' }
    ],
    record: {
      id_remu: '',
      id_conta: '',
      tax_regime_id: -1,
      biller_type_id: -1
    },
    addresses: [],
    partners: [],
    tmpAddress: { name: '', address: '' },
    tmpPartner: { rut: '', name: '', participation_perc: 100, birthday: ''}
  }),
  props: {
    editCompany: Object,
    taxRegimes: Array,
    billerTypes: Array,
    error: Boolean,
    strError: String
  },
  methods: {
    save () {
      this.$emit('company-form-func', this.company)
    },
    eventModal () {
      var Modal = document.querySelector('#modal')
      Modal.classList.toggle('is-active')
    },
    eventModalPartners () {
      var Modal = document.querySelector('#modalPartners')
      Modal.classList.toggle('is-active')
    },
    addAddress () {
      this.addresses.push({ name: this.tmpAddress.name, address: this.tmpAddress.address })
      this.tmpAddress.name = ''
      this.tmpAddress.address = ''
      this.eventModal()
    },
    addPartner () {
      this.partners.push({ rut: this.tmpPartner.rut, name: this.tmpPartner.name, participation_perc: this.tmpPartner.participation_perc })
      this.tmpPartner.rut = ''
      this.tmpPartner.name = ''
      this.tmpPartner.participation_perc = ''
      this.eventModalPartners()
    }
  },
  watch: {
    company: {
      handler (newValue) {
        this.company = newValue
        this.$emit('company-form-func', newValue)
      },
      deep: true
    }
  },
  computed: {
    fullRut: {
      get: function () {
        const rut = new Intl.NumberFormat('es-CL').format(this.company.rut)
        return this.company.rut.length > 0 ? rut + '-' + this.company.dv.replaceAll('-', '') : ''
      },
      set: function (newValue) {
        const local_rut = newValue.replaceAll('.', '').replaceAll('-', '').slice(0, -1)
        const local_dv = newValue.slice(-1).replaceAll('-', '')
        this.company.rut = local_rut
        this.company.dv = local_dv
      }
    }
  }
}
</script>

<style scoped>
.company-form {
  color: #241d16;
}

.company-form__intro {
  margin-bottom: 1.25rem;
}

.company-form__copy {
  max-width: 34rem;
  margin: 0;
  color: rgba(60, 46, 31, 0.62);
  font-size: 0.95rem;
  line-height: 1.55;
}

.company-form__fields {
  display: grid;
  gap: 1rem;
}

.company-form__field {
  margin-bottom: 0;
}

.company-form__label {
  margin-bottom: 0.45rem;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(70, 56, 42, 0.62);
}

.company-form__control {
  position: relative;
}

.company-form__input,
.company-form__select {
  min-height: 3.45rem;
  border: 1px solid rgba(96, 80, 61, 0.14);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  color: #231b14;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.9),
    0 10px 26px rgba(66, 48, 29, 0.05);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.company-form__input {
  padding: 0 1rem;
}

.company-form__input::placeholder {
  color: rgba(88, 71, 53, 0.4);
}

.company-form__input:hover,
.company-form__select:hover {
  border-color: rgba(96, 80, 61, 0.24);
}

.company-form__input:focus,
.company-form__select:focus {
  border-color: rgba(76, 59, 43, 0.38);
  box-shadow:
    0 0 0 4px rgba(112, 88, 60, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.92),
    0 14px 32px rgba(66, 48, 29, 0.08);
  background: rgba(255, 255, 255, 0.92);
}

.company-form__select-wrap {
  width: 100%;
}

.company-form__select-wrap::after {
  right: 1.2rem;
  border-color: #7d6a57;
}

.company-form__select {
  width: 100%;
  padding: 0 2.8rem 0 1rem;
  appearance: none;
}

.company-form__error {
  margin: 0.15rem 0 0;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(185, 28, 28, 0.08);
  border-radius: 16px;
  background: rgba(255, 241, 242, 0.88);
  color: #b42318;
  font-size: 0.92rem;
}

@media (max-width: 640px) {
  .company-form__copy {
    font-size: 0.9rem;
  }

  .company-form__input,
  .company-form__select {
    min-height: 3.2rem;
    border-radius: 16px;
  }
}
</style>

